function parallaxIcons() {
	const icons = document.querySelectorAll('.js-parallax-icon');
	if (icons.length > 0) {
		icons.forEach((icon) => {
			console.log(icon);
			gsap.fromTo(
				icon,
				{
					y: 50,
				},
				{
					y: -50,
					scrollTrigger: {
						trigger: icon,
						start: 'top bottom',
						end: 'bottom top',
						scrub: 1,
					},
				}
			);
		});
	}
}
